import { FC } from 'react';
import { Box, Typography, Grid, Card, CardMedia } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Post } from '../types/Post';
import { styled } from '@mui/material/styles';

interface PostsListProps {
  posts: Post[];
  category?: string;
}

const PostCard = styled(Card)(
  ({ theme }) => `
    background: ${theme.palette.background.paper};
    border-radius: ${theme.general.borderRadius};
    margin-bottom: ${theme.spacing(3)};
    transition: all .2s;
    cursor: pointer;
    overflow: hidden;
    
    &:hover {
      transform: translateY(-3px);
      box-shadow: ${theme.shadows[3]};
    }
`
);

const PostContent = styled(Box)(
  ({ theme }) => `
    padding: ${theme.spacing(3)};
`
);

const FeaturedImage = styled(CardMedia)(
  ({ theme }) => `
    height: 240px;
    background-size: cover;
    background-position: center;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50%;
      background: linear-gradient(to bottom, transparent, rgba(0,0,0,0.1));
    }
`
);

export const PostsList: FC<PostsListProps> = ({ posts, category }) => {
  const filteredPosts = category 
    ? posts.filter(post => post.category.toLowerCase() === category.toLowerCase())
    : posts;

  return (
    <Grid container spacing={3}>
      {filteredPosts.map((post) => (
        <Grid item xs={12} key={post.slug}>
          <RouterLink to={`/blog/post/${post.slug}`} style={{ textDecoration: 'none' }}>
            <PostCard>
              {post.featuredImage && (
                <FeaturedImage
                  image={post.featuredImage}
                  title={post.title}
                />
              )}
              <PostContent>
                <Typography variant="h3" sx={{ mb: 1 }}>
                  {post.title}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
                  {post.date} • {post.category}
                </Typography>
                <Typography variant="body1">
                  {post.excerpt}
                </Typography>
              </PostContent>
            </PostCard>
          </RouterLink>
        </Grid>
      ))}
    </Grid>
  );
}; 